import * as TraceKit from 'tracekit/tracekit';
import * as  _ from 'lodash';

export class ErrorLogger {
    constructor() {
        const _this = this;
        this.lastReportSents = [];
        if (!window.__env.enableDebug) {
            TraceKit.remoteFetching = false;
            TraceKit.report.subscribe(function xyz(e) {
                const locateError = _.find(_this.lastReportSents, (item) => { return e.message == item.message && item.mode == e.mode })
                _this.registerUserToken();
                if (locateError) {
                    if (locateError.triggered <= 2&&this.token) {
                        _this.sendReprot(e);
                    }
                    locateError.triggered++;
                }
                else {
                    _this.lastReportSents.push({ message: e.message, mode: e.mode, triggered: 1 });
                    if (_this.lastReportSents.length > 9) {
                        _this.lastReportSents = _this.lastReportSents.reverse().slice(0, 9); // we make sure we log last 10 report back prevent resend old report
                    }

                    if (_this.token)_this.sendReprot(e);
                }
            });
        }
    }

    registerUserToken() {
        if (typeof(Storage) !== "undefined") {
            const storageResponse = localStorage["ls.user"];
            if (storageResponse) {
                try {
                    this.token = JSON.parse(storageResponse).access_token;
                    if (this.token) this.token = this.token.replace(" ","");
                } catch(e) {
                    console.error("error log in fetching security token error log turn off")
                }
            }
        }
    }

    report(e) {
        if (!window.__env.enableDebug)
            TraceKit.report(e);
    }

    sendReprot(payload) {
        this._sendAjax(JSON.stringify({ message: JSON.stringify(payload) }));
    }

    _sendAjax(payload) {
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = function () {}
        xmlHttp.open("post", window.__env.error_route);
        xmlHttp.setRequestHeader("Authorization", `Bearer ${this.token}`);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(payload);
    }
}



// WEBPACK FOOTER //
// ./src/utils/errorlogger.js